import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { I18nModule, ProductSearchPage } from '@spartacus/core';
import { ProductListComponentService, SortingModule } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-facet-sort-select',
  standalone: true,
  imports: [CommonModule, I18nModule, SortingModule],
  templateUrl: './facet-sort-select.component.html',
  styleUrl: './facet-sort-select.component.scss',
})
export class FacetSortSelectComponent {
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;

  constructor(private productListComponentService: ProductListComponentService) {}

  sortList(sortCode: string): void {
    this.productListComponentService.sort(sortCode);
  }
}
